import { render, staticRenderFns } from "./RMSummary.vue?vue&type=template&id=30cbe9af"
import script from "./RMSummary.vue?vue&type=script&lang=js"
export * from "./RMSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports